
const StatsSection = () => {
  const stats = [
    {
      number: "2,500+",
      label: "Candidats accompagnés",
      icon: "ri-user-line"
    },
    {
      number: "850+",
      label: "Entreprises partenaires",
      icon: "ri-building-line"
    },
    {
      number: "95%",
      label: "Taux de satisfaction",
      icon: "ri-heart-line"
    },
    {
      number: "1,200+",
      label: "Emplois trouvés",
      icon: "ri-briefcase-line"
    }
  ];

  return (
    <section className="py-16 bg-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Notre Impact en Chiffres
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Depuis notre création, nous avons aidé des milliers de personnes 
            à trouver leur place sur le marché du travail rouennais
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-white text-2xl`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
                {stat.number}
              </div>
              <div className="text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
